import api from './';

export default {
  getParameterTypes() {
    return api.post('ParameterTypes/GetList', {}).then(response => response.data);
  },
};
